/**
 * Search 스타일
 * @description `Input` 과 달리 라벨도 헬퍼도 없고 모서리가 완전히 둥글다. 그래서 토큰도
 *   따로 있다(`--fw-search-*`). 테두리는 포커스에서 1 → 1.5 로 굵어진다 — 상자가 흔들리지
 *   않게 inset 그림자로 그린다.
 */
import { cva } from "class-variance-authority";

export const searchStyles = {
  root: cva(
    [
      "flex w-full items-center",
      "gap-[var(--fw-search-gap)]",
      "px-[var(--fw-search-padding-horizontal)]",
      "py-[var(--fw-search-padding-vertical)]",
      "rounded-[var(--fw-search-radius)]",
      "bg-[var(--fw-search-color-surface-rest)]",
    ],
    {
      variants: {
        disabled: {
          true: "shadow-[inset_0_0_0_var(--fw-search-stroke-width-rest)_var(--fw-search-color-stroke-disabled)]",
          false:
            "shadow-[inset_0_0_0_var(--fw-search-stroke-width-rest)_var(--fw-search-color-stroke-rest)] focus-within:shadow-[inset_0_0_0_var(--fw-search-stroke-width-pressed)_var(--fw-search-color-stroke-focused)]",
        },
      },
      defaultVariants: { disabled: false },
    },
  ),
  icon: "shrink-0 text-[var(--fw-search-color-content-field-rest-icon)]",
  field: [
    "fw-b1 min-w-0 flex-1 bg-transparent outline-none",
    "text-[var(--fw-search-color-content-field-filled)]",
    "placeholder:text-[var(--fw-search-color-content-field-rest)]",
    "disabled:text-[var(--fw-search-color-content-field-disabled)]",
    // 브라우저가 붙이는 기본 지우기 버튼을 숨긴다 — 우리 버튼과 겹친다.
    "[&::-webkit-search-cancel-button]:hidden",
  ].join(" "),
  clear:
    "shrink-0 cursor-pointer text-[var(--fw-search-color-content-field-rest-icon)]",
};
